<div class="order-pdf-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>picture_as_pdf</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Orden de Servicio</h2>
      <p class="dialog-header__context">{{ orderLabel }}</p>
    </div>
  </header>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'loading'">
    <div class="dialog-body--center">
      <mat-spinner [diameter]="40"></mat-spinner>
      <p class="state-title">Cargando PDF</p>
      <p class="state-subtitle">Preparando la vista previa del documento...</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'generating'">
    <div class="dialog-body--center">
      <mat-spinner [diameter]="40"></mat-spinner>
      <p class="state-title">Generando PDF</p>
      <p class="state-subtitle">
        El documento se está preparando. Se mostrará automáticamente cuando esté
        listo.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-content class="dialog-body" *ngIf="viewState === 'error'">
    <div class="alert alert--error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <strong *ngIf="displayedErrorTitleText">{{
          displayedErrorTitleText
        }}</strong>
        <span>{{ displayedErrorMessageText }}</span>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-content
    class="dialog-body dialog-body--viewer"
    *ngIf="viewState === 'view'"
  >
    <iframe
      *ngIf="sanitizedPdfResourceUrl"
      class="pdf-viewer"
      [src]="sanitizedPdfResourceUrl"
      title="Vista previa de la Orden de Servicio"
    ></iframe>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button
      mat-stroked-button
      type="button"
      class="co-btn co-btn--ghost"
      (click)="close()"
    >
      Cerrar
    </button>

    <button
      *ngIf="viewState === 'view'"
      mat-flat-button
      type="button"
      class="co-btn co-btn--primary"
      [disabled]="isDownloadingPdf"
      (click)="downloadPdf()"
    >
      <mat-spinner *ngIf="isDownloadingPdf" [diameter]="18"></mat-spinner>
      <span *ngIf="!isDownloadingPdf">Descargar PDF</span>
      <span *ngIf="isDownloadingPdf">Descargando...</span>
    </button>

    <button
      *ngIf="showRetryAction || showRefreshAction"
      mat-flat-button
      type="button"
      class="co-btn co-btn--primary"
      [disabled]="isRetryingPdfGeneration"
      (click)="retry()"
    >
      <mat-spinner
        *ngIf="isRetryingPdfGeneration"
        [diameter]="18"
      ></mat-spinner>
      <span *ngIf="!isRetryingPdfGeneration">{{
        showRefreshAction ? "Actualizar" : "Reintentar"
      }}</span>
      <span *ngIf="isRetryingPdfGeneration">{{
        showRefreshAction ? "Actualizando..." : "Reintentando..."
      }}</span>
    </button>
  </mat-dialog-actions>
</div>
